import axiosInstance from './axiosInstance';

export const LoginApi = async (username, password) => {
  try {
    const { data } = await axiosInstance.post(`/user/login`, { username: username, password: password });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DbBackupApi = async () => {
  try {
    const { data } = await axiosInstance.get(`/user/backup`);
    return data;
  } catch (err) {
    return false;
  }
};

export const AddUserApi = async (username, password, role_id, role_desc, company_id, permission_ids) => {
  try {
    const { data } = await axiosInstance.post(`/user`, {
      username: username,
      password: password,
      role_id: role_id,
      role_desc: role_desc,
      company_id: company_id,
      permission_ids: permission_ids,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditUserApi = async (p_user_id, username, password, role_id, role_desc, company_id, permission_ids) => {
  try {
    const { data } = await axiosInstance.put(`/user/${p_user_id}`, {
      username: username,
      password: password,
      role_id: role_id,
      role_desc: role_desc,
      company_id: company_id,
      permission_ids: permission_ids,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DeleteUser = async (p_user_id) => {
  try {
    const { data } = await axiosInstance.delete(`/user/${p_user_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const GetAllUserRoles = async () => {
  try {
    const { data } = await axiosInstance.get(`/role/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllUserPermissions = async () => {
  try {
    const { data } = await axiosInstance.get(`/permission/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetUserPermissions = async (p_user_id) => {
  try {
    const { data } = await axiosInstance.get(`/permission/user/${p_user_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetUserById = async (p_user_id) => {
  try {
    const { data } = await axiosInstance.get(`/user/Data/${p_user_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllUsers = async () => {
  try {
    const { data } = await axiosInstance.get('/user/list');
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetUserOnlyPermissions = async (p_user_id) => {
  try {
    const { data } = await axiosInstance.get(`/user/perm/${p_user_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddUserActivity = async (p_user_id, datetime, note) => {
  try {
    const { data } = await axiosInstance.post(`/user/activity/${p_user_id}`, { date_time: datetime, activity: note });
    return data;
  } catch (err) {
    if (err.response?.data) {
      return err.response.data;
    }
    throw err;
  }
};
